// JOBE-0044.14: filter-empty variant with drop-suggestion card.
//
// Renders the "no matches — drop a filter to widen" meta strip (above
// the table) and the suggestion card (below the table). The suggestion
// is computed by `suggestDrop` against the most recent non-empty page;
// when there's no cache to work from, the card surfaces a generic
// "Try removing a filter to widen the search." message.

import { suggestDrop } from './dropSuggestion.js';

export function FilterEmptyMeta() {
  return (
    <span
      className="library-state-filter-empty-meta"
      data-state="filter-empty-meta"
    >
      no matches — drop a filter to widen
    </span>
  );
}

export function FilterEmptyState({
  activeChips,
  lastNonEmptyPage,
  onRemoveChip,
}) {
  const suggestion = suggestDrop(activeChips, lastNonEmptyPage);

  return (
    <div
      className="library-table-empty library-state-filter-empty"
      data-state="filter-empty"
    >
      <p className="library-state-filter-empty-headline">No matches.</p>
      <div className="library-drop-suggestion-card">
        {suggestion ? (
          <>
            <p className="library-drop-suggestion-body">
              Dropping{' '}
              <code className="library-drop-suggestion-chip">
                {suggestion.chip.friendlyToken}
                :
                {(suggestion.chip.values || []).join(',')}
              </code>{' '}
              would yield {suggestion.count}{' '}
              {suggestion.count === 1 ? 'match' : 'matches'}.
            </p>
            <button
              type="button"
              className="library-drop-suggestion-action"
              onClick={() => onRemoveChip && onRemoveChip(suggestion.chip)}
            >
              Drop this filter
            </button>
          </>
        ) : (
          <p className="library-drop-suggestion-body">
            Try removing a filter to widen the search.
          </p>
        )}
      </div>
    </div>
  );
}
